import {useParams} from '@aboutyou/router';
import {getEntityIdFromRouteParam} from '@aboutyou/utils';

export const useOutfitIdentifier = () => {
  const {prefixedOutfitId} = useParams<{
    prefixedOutfitId?: string;
  }>();
  const outfitId = getEntityIdFromRouteParam(prefixedOutfitId);

  return outfitId
    ? {
        $case: 'id' as const,
        id: outfitId,
      }
    : null;
};
